module.exports = __webpack_public_path__ + "img/galleryHeader.3a5d7045.png";